import React from 'react';
import { Box, Text, Image, VStack } from '@chakra-ui/react';
import { apiEndPoint } from './StaticVar';

const FolderGrid = ({ folder, onOpen }) => {
  return (
    <VStack align="start" spacing={4} mb={6} cursor="pointer" w="100%" h="100%">
      <Box
        w="100%"
        h="0"
        pb="70%" // maintains aspect ratio (like 7:10 card)
        position="relative"
        overflow="hidden"
        borderRadius="md"
        onClick={onOpen}
        _hover={{ transform: "scale(1.01)", transition: "0.1s" }}
      >
        {folder["image_urls"].slice(0, 3).map((image, index) => (
          <Image
            key={image}
            src={`${apiEndPoint}/${image}`}
            alt={image.file_name}
            position="absolute"
            top={`${index * 4}px`}
            left={`${index * 4}px`}
            borderRadius="md"
            boxShadow="md"
            transform={`rotate(${index * 5 - 5}deg)`}
            objectFit="cover"
            w="100%"
            h="100%"
          />
        ))}
        <Text
          fontSize="xs"
          position="absolute"
          bottom={1}
          left="50%"
          transform="translateX(-50%)"
          bg="whiteAlpha.700"
          px={3}
          py={1}
          borderRadius="md"
          textAlign="center"
          // whiteSpace="nowrap"
        >
          {folder["name"]}
        </Text>
      </Box>
    </VStack>
  );
};

export default FolderGrid;